module.exports = __webpack_public_path__ + "static/roboto-black-08797e01fec8895e4c1df149bfc0edc5.woff";